// useDialog.js
import React, { useState, useCallback } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export function useDialog() {
  const [dialog, setDialog] = useState(null);

  const alert = useCallback((message, title = "Alert") => {
    return new Promise((resolve) => {
      setDialog({ type: "alert", title, message, resolve });
    });
  }, []);

  const confirm = useCallback((message, title = "Confirm") => {
    return new Promise((resolve) => {
      setDialog({ type: "confirm", title, message, resolve });
    });
  }, []);

  const prompt = useCallback((message, title = "Prompt", placeholder = "") => {
    return new Promise((resolve) => {
      setDialog({
        type: "prompt",
        title,
        message,
        placeholder,
        inputValue: "",
        resolve,
      });
    });
  }, []);

  const handleClose = (result = null) => {
    if (dialog?.resolve) dialog.resolve(result);
    setDialog(null);
  };

  const handleInputChange = (e) =>
    setDialog((prev) => (prev ? { ...prev, inputValue: e.target.value } : prev));

  // ✅ Helper: Check if message contains HTML
  const isHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

  const DialogModal = dialog ? (
    <Modal show={true} onHide={() => handleClose(null)} centered backdrop="static" keyboard={false}>
      {/* ❌ Hide header for alert modals */}
      {dialog.type !== "alert" && dialog.title && dialog.title !== "" && (
        <Modal.Header closeButton>
          <Modal.Title>{dialog.title}</Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body className="text-center">
        {isHTML(dialog.message) ? (
          <div dangerouslySetInnerHTML={{ __html: dialog.message }} />
        ) : (
          <p className="mb-0">{dialog.message}</p>
        )}

        {dialog.type === "prompt" && (
          <Form.Control
            className="mt-3"
            autoFocus
            value={dialog.inputValue || ""}
            onChange={handleInputChange}
            placeholder={dialog.placeholder}
          />
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        {dialog.type === "alert" ? (
          <Button variant="primary" onClick={() => handleClose(true)}>
            OK
          </Button>
        ) : (
          <>
            <Button variant="secondary" onClick={() => handleClose(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => handleClose(dialog.type === "prompt" ? dialog.inputValue : true)}
            >
              OK
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  ) : null;

  return { alert, confirm, prompt, DialogModal };
}
